const whitelabelConfig = {
    nhs: {
        brand: 'nhs',
        title: 'NHS Enable',
        scssVariables: './src/styles/whitelabel-variables/nhs',
        homePath: './src/views/nhs',
        legalDocsPath: './src/views/pages/nhs',
        icon: '/gonhs.ico',
        headerPath: './src/components/nhs',
        iconsPath: 'nhs/',
        destination: 'Perth Royal Infirmary, Urology Dept',
        support: 'https://support.gonhstayside.co.uk/portal/en/kb',
        ticket: 'https://support.gonhstayside.co.uk/portal/en/newticket?departmentId=38043000005771407&layoutId=38043000005815678',

    },
    raigmore: {
        brand: 'raigmore',
        title: 'Raigmore Connect',
        scssVariables: './src/styles/whitelabel-variables/raigmore',
        homePath: './src/views/raigmore',
        legalDocsPath: './src/views/pages/raigmore',
        icon: '/raigmore.ico',
        headerPath: './src/components/raigmore',
        iconsPath: 'raigmore/',
        destination: 'Raigmore Hospital, Inverness',
        support: 'https://support.raigmoreconnect.co.uk/portal/en/kb/raigmore-connect',
        ticket: 'https://support.raigmoreconnect.co.uk/portal/en/newticket?departmentId=38043000005771407&layoutId=38043000005815678',
    },
}
module.exports = whitelabelConfig
